import { createStoreForProduct } from './ProductStore'

export const RegionalDiscussionStore = createStoreForProduct('regionaldiscussion')
